angular.module('impactx.rfx').controller('AddToRFQSAskSupplierCtrl', [
    '$scope',
    '$mdDialog',
    'TranslationService',
    AddToRFQSAskSupplierCtrl
]);

function AddToRFQSAskSupplierCtrl($scope, $mdDialog, TranslationService) {
    var ctrl = this;
    ctrl.trns = {};
    ctrl.trns.cancel = TranslationService.get("abort");
    ctrl.trns.save = TranslationService.get("save");

    ctrl.cancel = function () {
        $mdDialog.cancel();
    }

    ctrl.save = function () {
        $mdDialog.hide();
    }
}